// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"4b14d014","560":"cab00149"}[chunkId] + ".chunk.js";
};